import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const styles = {
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff',
    backgroundColor: '#e0e0e0'
  },
  tableCellData: {
    border: '2px solid #ffffff'
  },
  userImage: {
    width: '100px',
    height: '100px'
  }
};

const enhance = compose(pure);

const ShopTable = enhance(
  ({
    classes,
    groupName,
    zipCode,
    prefectures,
    city,
    address,
    building,
    phone,
    fax,
    email,
    createdAt,
    updatedAt
  }) => {
    return (
      <Table className={classes.detailTable}>
        <TableRow>
          <TableCell className={classes.tableCellItem}>運営会社</TableCell>
          <TableCell className={classes.tableCellData}>{groupName}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.tableCellItem}>郵便番号</TableCell>
          <TableCell className={classes.tableCellData}>{zipCode}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.tableCellItem}>住所</TableCell>
          <TableCell className={classes.tableCellData}>
            {`${prefectures} ${city} ${address} ${building}`}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.tableCellItem}>電話番号</TableCell>
          <TableCell className={classes.tableCellData}>{phone}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.tableCellItem}>FAX</TableCell>
          <TableCell className={classes.tableCellData}>{fax}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.tableCellItem}>
            メールアドレス
          </TableCell>
          <TableCell className={classes.tableCellData}>{email}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.tableCellItem}>登録日時</TableCell>
          <TableCell className={classes.tableCellData}>{createdAt}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.tableCellItem}>更新日時</TableCell>
          <TableCell className={classes.tableCellData}>{updatedAt}</TableCell>
        </TableRow>
      </Table>
    );
  }
);

export default withStyles(styles)(ShopTable);
